import { Gender } from '@app/shared/enums/gender.enum';
import { ICountry } from '@app/shared/models/country.model';

export interface ICustomerData {
  id: string;
  firstName: string;
  lastName: string;
  nameInfix: string;

  mobileNumber: string;
  gender: Gender;
  email: string;
  country: ICountry;

  street?: string;
  houseNumber?: string;
  houseNumberSub?: string;
  postCode?: string;
  city?: string;
}
